import { createContext, useState } from 'react';

const ModalContext = createContext({
    status: false,
    showModal: () => {},
    closeModal: () => {}
});

export function ModalContextProvider({children}){
    const [modalStatus, setModalStatus] = useState(false);

    function showModal(){
        setModalStatus(true);
    }
    
    function closeModal(){
        setModalStatus(false);
    }

    const modalCtx = {
        status: modalStatus,
        showModal,
        closeModal
    }

    return <ModalContext.Provider value={modalCtx}>{children}</ModalContext.Provider>
}

export default ModalContext;